import { render, staticRenderFns } from "./FormConfig.vue?vue&type=template&id=4cadd1a7&scoped=true&"
import script from "./FormConfig.vue?vue&type=script&lang=js&"
export * from "./FormConfig.vue?vue&type=script&lang=js&"
import style0 from "./FormConfig.vue?vue&type=style&index=0&id=4cadd1a7&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cadd1a7",
  null
  
)

export default component.exports